import { apiRequest } from './base'

export interface EmailUnsubscribeMeta {
  url: string | null
  mailto: string | null
  oneClick: boolean
  unsubscribedAt: string | null
}

export interface EmailDetailResponse {
  id: string
  subject: string
  fromEmail: string
  senderName: string
  toEmail: string
  receivedAt: string
  direction: 'incoming' | 'outgoing'
  bodyText: string
  bodyHtml: string | null
  /** Present when the inbound email included a List-Unsubscribe header. */
  unsubscribe: EmailUnsubscribeMeta | null
}

export async function getEmailById(emailId: string): Promise<EmailDetailResponse> {
  return apiRequest<EmailDetailResponse>(`/inbox/emails/${emailId}`)
}

export type UnsubscribeResult =
  | { status: 'unsubscribed'; unsubscribedAt: string }
  | { status: 'failed'; url: string; mailto: string | null }
  | { status: 'manual'; url: string | null; mailto: string | null }

export async function unsubscribeEmail(emailId: string): Promise<UnsubscribeResult> {
  return apiRequest<UnsubscribeResult>(`/inbox/emails/${emailId}/unsubscribe`, {
    method: 'POST',
  })
}
